import PosSessionService from '@/api/PosSessionService'

// initial state
const state = {
  my: {
    sessions: [],
  },
  session: null,
  sessions: [],
}

// getters
const getters = {
  getPosSession: (state) => state.session,
  getPosSessions: (state) => state.sessions,
}

// mutations
const mutations = {
  setMySessions (state, data) {
    state.my.sessions = data
  },
  setPosSessions (state, data) {
    state.sessions = data
  },
  setPosSession (state, data) {
    state.session = data
  },
  updatePosMySessionStatus (state, data) {
    if (state.session) {
      state.session.status = data.status
    }
  },
}

// actions
const actions = {
  async getPosSessions ({ commit }, _params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosSessions') >= 0) return

    try {
      const params = _params === undefined
        ? null
        : {
          page: _params.page || 1,
          limit: _params.limit || 10,
          branch_id: _params.branch_id,
          status: _params.status,
        }

      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosSessions')

      let response = await PosSessionService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosSessions')

      result = response.data

      if (result.success) {
        commit('setPosSessions', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async getPosSession ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosSession') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosSession')

      let response = await PosSessionService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosSession')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setPosSession', result.data[0])
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async getPosMySession ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosMySession') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosMySession')

      let response = await PosSessionService.getMe()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosMySession')

      result = response.data

      if (result.success) {
        if (result.data.length > 0) {
          commit('setPosSession', result.data[0])
        }
        commit('setMySessions', result.data)
      } else {
        commit('setPosSession', null)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearPosSessions ({ commit }) {
    commit('setPosSessions', [])
  },
  clearPosSession ({ commit }) {
    commit('setPosSession', null)
  },
  async insertPosSession ({ commit }, params) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await PosSessionService.insert(params)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updatePosMySessionStatus ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await PosSessionService.updateStatus(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('updatePosMySessionStatus', data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/PosSession.js